import { createClient, plugins } from '../../../httpClient';
import { SsoSession, SsoSessionRaw } from './types';

export const makeSsoGatewayClient = (base?: string) => {
  if (!base) {
    return;
  }
  const client = createClient(
    new URL('/api/', base).href,
    plugins.throwOnResponse,
    plugins.addCookiesToRequest,
  );

  return {
    getSession: (): Promise<SsoSession> =>
      client('v1/session')
        .then((res) => res.json<SsoSessionRaw>())
        .then(
          ({
            IP,
            Email,
            CreatedAt,
            Linked,
            FirstName,
            LastName,
            LastActive,
            Location,
            RequiredPasswordUpdate,
            GUID,
            UserGUID,
            UserID,
          }) => ({
            ip: IP,
            email: Email,
            createdAt: CreatedAt,
            linked: Linked,
            firstName: FirstName,
            lastName: LastName,
            lastActive: LastActive,
            location: Location,
            requiredPasswordUpdate: RequiredPasswordUpdate,
            guid: GUID,
            userGUID: UserGUID,
            userID: UserID,
          }),
        ),
  };
};

export type SsoGatewayClient = ReturnType<typeof makeSsoGatewayClient>;
